import { ProductsListingApiResponse } from '../typings/product';
import api from './baseApi';

export const getProductsWithCount = async (
    store: string,
    searchString: string,
    from: number,
    count: number,
    includeVariants = false,
    linkedProducts: number
): Promise<ProductsListingApiResponse> => {
    const response = await api.get('products', {
        params: {
            searchString: searchString,
            from: from,
            limit: count,
            shop: store,
            includeVariants: includeVariants,
            linkedProducts: linkedProducts
        }
    });

    return response.data;
};
